var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "pp-filter-panel", style: _vm.panelStyle },
    [
      _c(
        "div",
        { staticClass: "pp-filter-header d-flex align-center px-4 py-3" },
        [
          _c("v-icon", { staticClass: "mr-2", attrs: { small: "" } }, [
            _vm._v("mdi-filter-variant"),
          ]),
          _c("span", { staticClass: "text-subtitle-1 font-weight-medium" }, [
            _vm._v("Filters"),
          ]),
          _c("v-spacer"),
          _c(
            "v-btn",
            {
              attrs: { icon: "", small: "", "aria-label": "Close filters" },
              on: {
                click: function ($event) {
                  return _vm.$emit("close")
                },
              },
            },
            [_c("v-icon", [_vm._v("mdi-close")])],
            1
          ),
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "div",
        { staticClass: "pp-filter-body flex-grow-1 px-4 py-3" },
        [
          _c("v-autocomplete", {
            staticClass: "mb-4",
            attrs: {
              label: "Promo Category",
              items: _vm.sortedPromoCat,
              "item-text": "name",
              "item-value": "id",
              multiple: "",
              "small-chips": "",
              "deletable-chips": "",
              "hide-details": "",
              clearable: "",
              outlined: "",
              dense: "",
            },
            on: {
              change: _vm.handlePromoCatChange,
              "click:clear": function ($event) {
                return _vm.removeFilter("promo_category_name", true)
              },
            },
            model: {
              value: _vm.params.promo_category_name,
              callback: function ($$v) {
                _vm.$set(_vm.params, "promo_category_name", $$v)
              },
              expression: "params.promo_category_name",
            },
          }),
          _c("v-autocomplete", {
            staticClass: "mb-4",
            attrs: {
              label: "Department",
              items: _vm.sortedDepartments,
              "item-text": "name",
              "item-value": "id",
              multiple: "",
              "small-chips": "",
              "deletable-chips": "",
              "hide-details": "",
              clearable: "",
              outlined: "",
              dense: "",
            },
            on: {
              change: _vm.handleDepartmentChange,
              "click:clear": function ($event) {
                return _vm.removeFilter("department", true)
              },
            },
            model: {
              value: _vm.params.department,
              callback: function ($$v) {
                _vm.$set(_vm.params, "department", $$v)
              },
              expression: "params.department",
            },
          }),
          _c("v-autocomplete", {
            staticClass: "mb-4",
            attrs: {
              label: "Category",
              items: _vm.sortedCategories,
              "item-text": "name",
              "item-value": "id",
              multiple: "",
              "small-chips": "",
              "deletable-chips": "",
              "hide-details": "",
              clearable: "",
              outlined: "",
              dense: "",
            },
            on: {
              change: _vm.handleCategoryChange,
              "click:clear": function ($event) {
                return _vm.removeFilter("category", true)
              },
            },
            model: {
              value: _vm.params.category,
              callback: function ($$v) {
                _vm.$set(_vm.params, "category", $$v)
              },
              expression: "params.category",
            },
          }),
          _vm.$auth.tenant === "awg"
            ? _c("v-autocomplete", {
                staticClass: "mb-4",
                attrs: {
                  label: "Subcategory",
                  items: _vm.sortedSubcategories,
                  "item-text": "name",
                  "item-value": "id",
                  multiple: "",
                  "small-chips": "",
                  "deletable-chips": "",
                  "hide-details": "",
                  clearable: "",
                  outlined: "",
                  dense: "",
                },
                on: {
                  change: _vm.handleSubcategoryChange,
                  "click:clear": function ($event) {
                    return _vm.removeFilter("subcategory", true)
                  },
                },
                model: {
                  value: _vm.params.subcategory,
                  callback: function ($$v) {
                    _vm.$set(_vm.params, "subcategory", $$v)
                  },
                  expression: "params.subcategory",
                },
              })
            : _vm._e(),
          _c("v-autocomplete", {
            staticClass: "mb-4",
            attrs: {
              label: "Vendor",
              items: _vm.sortedVendors,
              "item-text": "name",
              "item-value": "id",
              multiple: "",
              "small-chips": "",
              "deletable-chips": "",
              "hide-details": "",
              clearable: "",
              outlined: "",
              dense: "",
            },
            on: {
              change: _vm.handleVendorChange,
              "click:clear": function ($event) {
                return _vm.removeFilter("vendor", true)
              },
            },
            model: {
              value: _vm.params.vendor,
              callback: function ($$v) {
                _vm.$set(_vm.params, "vendor", $$v)
              },
              expression: "params.vendor",
            },
          }),
          _vm.$auth.tenant === "alliance-retail-group"
            ? _c("v-autocomplete", {
                staticClass: "mb-4",
                attrs: {
                  label: "Private Label AMAPs",
                  items: [
                    { text: "Only Include Private Label AMAPs", value: true },
                    { text: "Exclude Private Label AMAPs", value: false },
                  ],
                  "item-text": "text",
                  "item-value": "value",
                  "hide-details": "",
                  clearable: "",
                  outlined: "",
                  dense: "",
                },
                on: {
                  change: _vm.handleIsPrivateLabelChange,
                  "click:clear": function ($event) {
                    return _vm.removeFilter("private_label_indicator", true)
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "selection",
                      fn: function ({ item }) {
                        return [_c("span", [_vm._v(_vm._s(item.text))])]
                      },
                    },
                  ],
                  null,
                  false,
                  460923026
                ),
                model: {
                  value: _vm.params.private_label_indicator,
                  callback: function ($$v) {
                    _vm.$set(_vm.params, "private_label_indicator", $$v)
                  },
                  expression: "params.private_label_indicator",
                },
              })
            : _vm._e(),
          _vm.$auth.tenant === "alliance-retail-group" &&
          _vm.batch_type === "NON PERISHABLE"
            ? _c("v-autocomplete", {
                staticClass: "mb-4",
                attrs: {
                  label: "VMC Items",
                  items: [
                    { text: "Only Include VMC Items", value: true },
                    { text: "Exclude VMC Items", value: false },
                  ],
                  "item-text": "text",
                  "item-value": "value",
                  "hide-details": "",
                  clearable: "",
                  outlined: "",
                  dense: "",
                },
                on: {
                  change: _vm.handleVmcOnlyChange,
                  "click:clear": function ($event) {
                    return _vm.removeFilter("vmc_only", true)
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "selection",
                      fn: function ({ item }) {
                        return [_c("span", [_vm._v(_vm._s(item.text))])]
                      },
                    },
                  ],
                  null,
                  false,
                  460923026
                ),
                model: {
                  value: _vm.params.vmc_only,
                  callback: function ($$v) {
                    _vm.$set(_vm.params, "vmc_only", $$v)
                  },
                  expression: "params.vmc_only",
                },
              })
            : _vm._e(),
          _c("v-textarea", {
            staticClass: "mb-4",
            attrs: {
              label: "Linked Group",
              "background-color": "input",
              "hide-details": "auto",
              dense: "",
              outlined: "",
              "auto-grow": "",
              rows: "1",
              clearable: "",
              hint: "Press 'Enter' to add multiple search criteria.",
            },
            on: {
              keydown: function ($event) {
                return _vm.handleKeydown($event, "linked_group")
              },
              "click:clear": function ($event) {
                return _vm.removeFilter("linked_group", true)
              },
            },
            model: {
              value: _vm.params.linked_group,
              callback: function ($$v) {
                _vm.$set(_vm.params, "linked_group", $$v)
              },
              expression: "params.linked_group",
            },
          }),
          _vm.$auth.tenant === "alliance-retail-group"
            ? _c("v-autocomplete", {
                staticClass: "mb-4",
                attrs: {
                  label: "Compete/ePay Filter",
                  items: [
                    { text: "Exclude Compete/ePay", value: false },
                    { text: "Only Include Compete/ePay", value: true },
                  ],
                  "item-text": "text",
                  "item-value": "value",
                  "hide-details": "",
                  clearable: "",
                  outlined: "",
                  dense: "",
                },
                on: {
                  change: _vm.handleFilterCompeteEpayChange,
                  "click:clear": function ($event) {
                    return _vm.removeFilter("filter_compete_epay", true)
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "selection",
                      fn: function ({ item }) {
                        return [_c("span", [_vm._v(_vm._s(item.text))])]
                      },
                    },
                  ],
                  null,
                  false,
                  460923026
                ),
                model: {
                  value: _vm.params.filter_compete_epay,
                  callback: function ($$v) {
                    _vm.$set(_vm.params, "filter_compete_epay", $$v)
                  },
                  expression: "params.filter_compete_epay",
                },
              })
            : _vm._e(),
          _c("v-textarea", {
            staticClass: "mb-4",
            attrs: {
              label: "Item ID",
              "background-color": "input",
              "hide-details": "auto",
              dense: "",
              outlined: "",
              "auto-grow": "",
              rows: "1",
              clearable: "",
              hint: "Press 'Enter' to add multiple search criteria.",
            },
            on: {
              keydown: function ($event) {
                return _vm.handleKeydown($event, "item_id")
              },
              "click:clear": function ($event) {
                return _vm.removeFilter("item_id", true)
              },
            },
            model: {
              value: _vm.params.item_id,
              callback: function ($$v) {
                _vm.$set(_vm.params, "item_id", $$v)
              },
              expression: "params.item_id",
            },
          }),
          _c("v-textarea", {
            staticClass: "mb-4",
            attrs: {
              label: "UPC",
              "background-color": "input",
              "hide-details": "auto",
              dense: "",
              outlined: "",
              "auto-grow": "",
              rows: "1",
              clearable: "",
              hint: "Press 'Enter' to add multiple search criteria.",
            },
            on: {
              keydown: function ($event) {
                return _vm.handleKeydown($event, "upc")
              },
              "click:clear": function ($event) {
                return _vm.removeFilter("upc", true)
              },
            },
            model: {
              value: _vm.params.upc,
              callback: function ($$v) {
                _vm.$set(_vm.params, "upc", $$v)
              },
              expression: "params.upc",
            },
          }),
          _vm.$auth.tenant === "alliance-retail-group"
            ? _c("v-textarea", {
                staticClass: "mb-4",
                attrs: {
                  label: "Order Book Index",
                  "background-color": "input",
                  "hide-details": "auto",
                  dense: "",
                  outlined: "",
                  "auto-grow": "",
                  rows: "1",
                  clearable: "",
                  hint: "Press 'Enter' to add multiple search criteria.",
                },
                on: {
                  keydown: function ($event) {
                    return _vm.handleKeydown($event, "order_book_index")
                  },
                  "click:clear": function ($event) {
                    return _vm.removeFilter("order_book_index", true)
                  },
                },
                model: {
                  value: _vm.params.order_book_index,
                  callback: function ($$v) {
                    _vm.$set(_vm.params, "order_book_index", $$v)
                  },
                  expression: "params.order_book_index",
                },
              })
            : _vm._e(),
          _c("v-textarea", {
            staticClass: "mb-4",
            attrs: {
              label: "Description",
              "background-color": "input",
              "hide-details": "auto",
              dense: "",
              outlined: "",
              "auto-grow": "",
              rows: "1",
              clearable: "",
            },
            on: {
              keydown: function ($event) {
                return _vm.handleKeydown($event, "description")
              },
              "click:clear": function ($event) {
                return _vm.removeFilter("description", true)
              },
            },
            model: {
              value: _vm.params.description,
              callback: function ($$v) {
                _vm.$set(_vm.params, "description", $$v)
              },
              expression: "params.description",
            },
          }),
          _c("v-textarea", {
            staticClass: "mb-4",
            attrs: {
              label: "Notes",
              "background-color": "input",
              "hide-details": "auto",
              dense: "",
              outlined: "",
              "auto-grow": "",
              rows: "1",
              clearable: "",
            },
            on: {
              keydown: function ($event) {
                return _vm.handleKeydown($event, "notes")
              },
              "click:clear": function ($event) {
                return _vm.removeFilter("notes", true)
              },
            },
            model: {
              value: _vm.params.notes,
              callback: function ($$v) {
                _vm.$set(_vm.params, "notes", $$v)
              },
              expression: "params.notes",
            },
          }),
          _c("v-autocomplete", {
            staticClass: "mb-4",
            attrs: {
              label: "Shippers/Pallets Filter",
              items: [
                { text: "Exclude Shippers/Pallets", value: false },
                { text: "Only Include Shippers/Pallets", value: true },
              ],
              "item-text": "text",
              "item-value": "value",
              "hide-details": "",
              clearable: "",
              outlined: "",
              dense: "",
            },
            on: {
              change: _vm.handleIsShipperChange,
              "click:clear": function ($event) {
                return _vm.removeFilter("is_shipper", true)
              },
            },
            scopedSlots: _vm._u([
              {
                key: "selection",
                fn: function ({ item }) {
                  return [_c("span", [_vm._v(_vm._s(item.text))])]
                },
              },
            ]),
            model: {
              value: _vm.params.is_shipper,
              callback: function ($$v) {
                _vm.$set(_vm.params, "is_shipper", $$v)
              },
              expression: "params.is_shipper",
            },
          }),
          _vm.$auth.tenant === "alliance-retail-group"
            ? _c("v-autocomplete", {
                staticClass: "mb-4",
                attrs: {
                  label: "Top Seller Filter",
                  items: [
                    { text: "Exclude Top Sellers", value: false },
                    { text: "Only Include Top Sellers", value: true },
                  ],
                  "item-text": "text",
                  "item-value": "value",
                  "hide-details": "",
                  clearable: "",
                  outlined: "",
                  dense: "",
                },
                on: {
                  change: _vm.handleTopSellersChange,
                  "click:clear": function ($event) {
                    return _vm.removeFilter("top_sellers", true)
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "selection",
                      fn: function ({ item }) {
                        return [_c("span", [_vm._v(_vm._s(item.text))])]
                      },
                    },
                  ],
                  null,
                  false,
                  460923026
                ),
                model: {
                  value: _vm.params.top_sellers,
                  callback: function ($$v) {
                    _vm.$set(_vm.params, "top_sellers", $$v)
                  },
                  expression: "params.top_sellers",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "div",
        { staticClass: "pp-filter-footer d-flex align-center px-4 py-3" },
        [
          _c(
            "v-btn",
            {
              attrs: {
                text: "",
                small: "",
                color: "primary",
                disabled: _vm.activeFilters.length === 0,
              },
              on: { click: _vm.removeAllFilters },
            },
            [_vm._v(" Clear all ")]
          ),
          _c("v-spacer"),
          _c(
            "v-btn",
            {
              attrs: { small: "", color: "primary", depressed: "" },
              on: { click: _vm.applyFilters },
            },
            [_vm._v("Apply")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }